import React, { useMemo, useState, useEffect } from 'react';
import { Col, Row, Button } from 'antd';
import styles from './index.less';
import GeneralLayout from '../../layouts/general';
import { CommonSectionLayout } from 'src/components/POSWebsite/legacy';
import { JoinClassName } from 'src/utils/utils';
import FeaturedArticle from './FeaturedArticle';
import PreviewArticleCard from './PreviewArticleCard';
import Link from 'next/link';
import { getArticles, fetchDataByLocale, getFeaturedArticleByCategory } from '../../server-services/contentful';
import { localeSelector } from '../../selector/app';
import { CONTENTFUL_LOCAL_EN, CONTENTFUL_LOCAL_ZH } from 'src/utils/contentful';
import { useSelector } from 'react-redux';
import { FormattedMessage, useIntl } from 'react-intl';
import cookie from 'cookie';
import useLocale from 'src/hooks/useLocale';
const BlogFrontPage = ({
  topArticles: _shuffle_topArticles_,
  otherArticles: _otherArticles_,
  totalPages: _totalPages_,
  featuredArticle: _featuredArticle_,
}) => {
  const intl = useIntl();
  const _locale_ = useSelector(localeSelector);
  const locale = useLocale();

  const { topArticles, otherArticles, totalPages, featuredArticle } = useMemo(() => {
    let contentfulLocale = CONTENTFUL_LOCAL_EN;
    if (locale === 'en') {
      contentfulLocale = CONTENTFUL_LOCAL_EN;
    } else {
      contentfulLocale = CONTENTFUL_LOCAL_ZH;
    }

    return {
      topArticles: _shuffle_topArticles_.map((article) => {
        return article[contentfulLocale];
      }),
      otherArticles: _otherArticles_.map((article) => {
        return article[contentfulLocale];
      }),
      totalPages: _totalPages_,
      featuredArticle: _featuredArticle_ ? _featuredArticle_[contentfulLocale] : null,
    };
  }, [locale, _shuffle_topArticles_, _otherArticles_, _totalPages_]);

  const pageTitle = featuredArticle ? featuredArticle.fields.title : '';
  const pageFeaturedImage = (featuredArticle ? featuredArticle.fields?.featureImage : null)?.fields.file.url || '';

  return (
    <GeneralLayout
      pageClass="blogs-page full-width-page"
      pageTitle={pageTitle ? pageTitle : 'POS Blogs | Chowbus POS'}
      pageId="pos-blogs"
      pageFeaturedImage={pageFeaturedImage}
    >
      <div className={JoinClassName(styles.PageBlogs)}>
        <FeaturedArticle article={featuredArticle} />
        <div className={JoinClassName(styles.topArticles)}>
          <CommonSectionLayout backgroundColor="#ffffff" title={''} description={''}>
            <Row gutter={[{ xs: 0, sm: 16, md: 16 }, 16]}>
              {topArticles.map((article, index) => {
                return (
                  <Col key={index} xs={24} sm={12} md={12} lg={6}>
                    <PreviewArticleCard article={article} layout="vertical" />
                  </Col>
                );
              })}
            </Row>
          </CommonSectionLayout>
        </div>
        {otherArticles && otherArticles.length !== 0 && (
          <div className={JoinClassName(styles.otherArticles)}>
            <CommonSectionLayout backgroundColor="#ffffff" title={''} description={''}>
              <div className={JoinClassName(styles.otherArticleTitle)}>
                <span>
                  <FormattedMessage id="home.blog.othersarticle" />
                </span>
              </div>
              <Row gutter={[{ xs: 0, sm: 16, md: 16 }, 16]}>
                {otherArticles.map((article, index) => {
                  return (
                    <Col key={index} xs={24}>
                      <PreviewArticleCard article={article} showPreview={true} />
                    </Col>
                  );
                })}
              </Row>
              {totalPages > 1 && (
                <div className={JoinClassName(styles.articleReadMoreButton)}>
                  <Button type="primary" className={JoinClassName(styles.articleReadMore)}>
                    <Link href="/blog/all/[page]" as="/blog/all/1">
                      {intl.formatMessage({ id: 'home.blog.viewmore.button' })}
                    </Link>
                  </Button>
                </div>
              )}
            </CommonSectionLayout>
          </div>
        )}
      </div>
    </GeneralLayout>
  );
};
export default BlogFrontPage;

function shuffle(arr) {
  let i = arr.length;
  while (i) {
    let j = Math.floor(Math.random() * i--);
    [arr[j], arr[i]] = [arr[i], arr[j]];
  }
}

export async function getServerSideProps(context) {
  const { params, req, res, locale } = context;
  const articles = await getArticles({ page: 1, pageSize: 8 });

  let featuredArticleList = await getFeaturedArticleByCategory('featured-blog', 10);
  const cookies = cookie.parse(req ? req.headers.cookie || '' : '');
  const defualtLang = locale || cookies['pos.locale'] || 'en';
  const featuredBlogRandom = cookies['pos.blogs.featured'];
  let offset = 5 - featuredArticleList.length;
  if (offset > 0) {
    featuredArticleList.push(...(articles ? articles.items.slice(0, offset) : []));
  }
  let topFeaturedBlogs = [...(featuredArticleList || []).map(fetchDataByLocale)];

  const setupFeaturedBlogCooke = (topArticlesKey) => {
    var expiredTime = new Date();
    var minutes = 10;
    expiredTime.setTime(new Date().getTime() + minutes * 60 * 1000);
    context.res.setHeader(
      'Set-Cookie',
      `pos.blogs.featured=${topArticlesKey};expires=${expiredTime.toUTCString()};path=/;`
    );
  };

  if (featuredBlogRandom) {
    let prevSelected = featuredBlogRandom.split('`');
    let reduceResult = (topFeaturedBlogs || []).reduce(
      (result, item) => {
        if (!item) {
          return result;
        }
        let matchedIndex = prevSelected.indexOf(item[CONTENTFUL_LOCAL_EN].fields.urlTitle);
        if (matchedIndex !== -1) {
          result.matched[matchedIndex] = item;
        } else {
          result.notMatched.push(item);
        }
        return result;
      },
      {
        matched: [],
        notMatched: [],
      }
    );

    reduceResult.matched = reduceResult.matched
      .map((item) => {
        if (!item) {
          return reduceResult.notMatched.shift;
        }
        return item;
      })
      .filter((item) => !!item);
    let topArticlesKey = reduceResult.matched
      .map((article) => {
        return article[CONTENTFUL_LOCAL_EN].fields.urlTitle;
      })
      .join('`');

    if (topArticlesKey !== featuredBlogRandom) {
      setupFeaturedBlogCooke(topArticlesKey);
    }

    topFeaturedBlogs = reduceResult.matched;
  } else {
    //if not existed on cookie,then create it
    shuffle(topFeaturedBlogs);
    let topArticlesKey = topFeaturedBlogs
      .map((article) => {
        return article[CONTENTFUL_LOCAL_EN].fields.urlTitle;
      })
      .join('`');
    setupFeaturedBlogCooke(topArticlesKey);
  }

  return {
    props: {
      topArticles: topFeaturedBlogs.slice(1, 5),
      otherArticles: (articles ? articles.items.slice(4) : []).map(fetchDataByLocale).filter((item) => !!item),
      totalPages: articles ? articles.totalPages : 0,
      featuredArticle: topFeaturedBlogs[0],
      defualtLang,
    },
    // Next.js will attempt to re-generate the page:
    // - When a request comes in
    // - At most once every 10 seconds
    // revalidate: 60, // In seconds
  };
}
